var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-card',{attrs:{"title":_vm.getMessage_('QWCC002069')}},[_c('sf-data-table',{ref:"grpTable",attrs:{"index":"","height":"350px","paging":false,"excel":_vm.isButton_(_vm.scrId, 'EX'),"columns":_vm.cols,"rows":_vm.rows,"stripe":false,"selection":false}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }